import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.JensenTelephonyAccounts = routerStyxie({ actions: ['index', 'new', 'edit']})
